import { render } from "./Subtitles.vue?vue&type=template&id=6b075ebb&scoped=true"
import script from "./Subtitles.vue?vue&type=script&lang=js"
export * from "./Subtitles.vue?vue&type=script&lang=js"

import "./Subtitles.vue?vue&type=style&index=0&id=6b075ebb&scoped=true&lang=css"

import exportComponent from "E:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b075ebb"]])

export default __exports__